import moment from 'moment'

const calcCompareRange = (start, end) => {
  let diffDays = end.diff(start, 'days')
  let startDate, endDate
  endDate = moment(start).subtract(1, 'day')
  if (diffDays <= 7) {
    startDate = moment(endDate).subtract(diffDays, 'days')
  } else if (diffDays > 7) {
    startDate = moment(endDate).startOf('month')
  }

  return {
    startDate: startDate,
    endDate: endDate
  }
}

const calcDateRange = (range) => {
  let startDate, endDate
  switch (range) {
    case 'Today':
      startDate = moment()
      endDate = moment()
      break
    case 'Yesterday' :
      startDate = moment().subtract(1, 'day')
      endDate = startDate
      break
    case 'Last 7 Days':
      startDate = moment().subtract(7, 'days')
      endDate = moment().subtract(1, 'day')
      break
    case 'Last Week':
      startDate = moment().startOf('week').subtract(1, 'week')
      endDate = moment(startDate).add(6, 'days')
      break
    case 'This Month':
      startDate = moment().startOf('month')
      endDate = moment()
      break
    case 'Last Month':
      startDate = moment().startOf('month').subtract(1, 'month')
      endDate = moment(startDate).endOf('month')
      break
    case 'Last 12 Months':
      startDate = moment().subtract(12, 'months').startOf('month')
      endDate = moment().startOf('month').subtract(1, 'month').endOf('month')
      break
  }
  return {
    startDate: startDate,
    endDate: endDate
  }
}

const getDefaultState = () => {
  let startOfMonth = moment().startOf('month')
  let currentDate = moment()
  return {
    dates: {
      startDate: startOfMonth,
      endDate: currentDate
    },
    compareDates: calcCompareRange(startOfMonth, currentDate, 'months'),
    compareTo: 'Previous period',
    range: 'Last 7 Days'
  }
}

const state = getDefaultState()

const getters = {
  datesParams (state) {
    return {
      range: state.range,
      compareTo: state.compareTo
    }
  },
  reportDates (state) {
    return {
      startDate: state.dates.startDate.format('MM/DD/YYYY'),
      endDate: state.dates.endDate.format('MM/DD/YYYY'),
      compareStartDate: state.compareDates.startDate.format('MM/DD/YYYY'),
      compareEndDate: state.compareDates.endDate.format('MM/DD/YYYY')
    }
  },
  compareToOptios () {
    return [
      'Previous period',
      'Custom Dates',
      'Do not compare'
    ]
  },
  defaultDateRanges () {
    return [
      'Today',
      'Yesterday',
      'Last 7 Days',
      'Last Week',
      'This Month',
      'Last Month',
      'Last 12 Months',
      'Custom Dates'
    ]
  }
}

const mutations = {
  setReportDates (state, dates) {
    state.dates = dates
  },
  setRange (state, range) {
    state.range = range
    if (range !== 'Custom Dates') {
      state.dates = calcDateRange(range)
      state.compareDates = calcCompareRange(state.dates.startDate, state.dates.endDate)
    }
  },
  setDates (state, {key, date}) {
    state.dates[key] = moment(date)
  },
  setCompareToDates (state, {key, date}) {
    state.compareDates[key] = moment(date)
  },
  setCompareTo (state, compareTo) {
    state.compareTo = compareTo
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/report_dates.js